import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import InputMask from "react-input-mask";
import { validate } from "../../../services/cpfService"

import { Modal, ModalBody } from 'reactstrap';
import { from } from "zen-observable";

class FormSecondStep extends Component {
    constructor(props){
        super(props)

        this.state = {
            characteres: 0,
            validCpf: true
        }

        this.countCharacters = this.countCharacters.bind(this);
        this.invalidInput = this.invalidInput.bind(this);
        this.validateCPF = this.validateCPF.bind(this);
    }

    validateCPF(event){
        this.setState({
            validCpf: validate(event.target.value)
        })
    }

    countCharacters(event){
        let char = event.target.value.split(" ").join("")
        
        this.setState({
            invalidInput: false
        })

        if (char.split("-").join("").length <= 11) {
            this.setState({
                characteres: char.split("-").join("").length + 1
            })
        }
    }

    invalidInput() {
        this.setState({
            invalidInput: true
        })
    }

    render() {
        return (
            <div className="form">
                {this.props.isCpfRegister ? 
                    <p>Finalizar seu cadastro em</p>
                :
                    <p>Cadastrar em</p>
                }
               <h1>{this.props.isCpfRegister ? this.props.companyName : this.props.departmentName}</h1>

               <form className="step-2" onSubmit={this.props.submitForm}>
                    <input name="name" type="text" placeholder="Nome Completo" required/>
                    <InputMask name="phone" type="text" placeholder="Telefone" onChange={this.countCharacters} onFocus={this.removeInvalid} mask={this.state.characteres <= 11 ? "99 9999-99999" : "99 99999-9999"} maskChar="" className={this.state.invalidInput && 'invalidInput'} required/>
                    {this.state.invalidInput && 
                        <label className="invalidInputLabel">
                            Por favor, insira um telefone válido
                        </label>}
                    {this.props.isCpfRegister ?
                      <input name="email" type="email" className={this.props.emailAlreadUsed ? 'invalidInput' : undefined} placeholder="E-mail" required/> 
                      :
                      <InputMask mask="999.999.999-99" placeholder="CPF" name="cpf" onBlur={this.validateCPF} className={!(this.state.validCpf) || this.props.alreadyRegisteredCpf ? 'invalidInput' : undefined} required />
                    }
                    {
                        this.props.isCpfRegister && this.props.emailAlreadUsed &&
                            <label className="invalidInputLabel">
                                Este e-mail já foi registrado nesta instituição
                            </label>
                    }
                    {
                        (!this.props.isCpfRegister && !this.state.validCpf) ?
                            <label className="invalidInputLabel">
                                Por favor, insira um CPF válido
                            </label>
                        : this.props.alreadyRegisteredCpf &&
                            <label className="invalidInputLabel">
                                Este CPF já foi registrado nesta instituição
                            </label>
                    }
                    
                    {
                        this.state.characteres < 11 ?
                            <button type="button" onClick={this.invalidInput}>Cadastrar</button>
                        : !this.state.validCpf ?
                            <button type="button">Cadastrar</button>
                        :
                            <button type="submit">Cadastrar</button>
                    }
               </form>
                    <Modal isOpen={this.props.modal} toggle={this.props.toggle} className="modalApprove">
                        <ModalBody>
                            <div>
                            <p>{this.props.isCpfRegister ? 'Você está se cadastrando para o Escala' : 'Você está se cadastrando para a escala'}</p>
                            <h1>{this.props.isCpfRegister ? this.props.companyName : this.props.departmentName}</h1>
                            {!this.props.isCpfRegister && <label><img className="location-icon" src="assets/images/icon_location.svg"/>{this.props.locationModal}</label>}
                            </div>
                            <button className="submit" onClick={this.props.confirmModal}>confirmar</button>
                            <button onClick={this.props.toggle}>cancelar</button>
                        </ModalBody>
                    </Modal>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    app: state.app
});

const mapDispatchToProps = dispatch => bindActionCreators({ }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(FormSecondStep);




// WEBPACK FOOTER //
// ./src/app/home/container/formSecondStep.js